<template>
	<v-dialog v-model="dialog" max-width="400px" v-if="!logged_in">
		<template v-slot:activator="{ on }">
			<v-btn v-bind="size" :color="color" dark class="ml-2 mr-2" v-on="on"><v-icon small class="mr-3">mdi-login-variant</v-icon>Log In</v-btn>       
		</template>
		<Login v-on:loggedIn="dialog = false"></Login>
			
	</v-dialog>    	
</template>

<script>
	import Login from "../../../x.m.works/src/components/Login.vue"
	import Vuex from 'vuex'
	export default{
		name: "LoginModal", 
		props: ["size", "color"],
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				logged_in: state => state.auth.logged_in,
			}),
		},
		components: {
			Login, 
		},
		data: () => {
			return {
				dialog: false
			}
		}

	}
</script>